import { css } from 'styled-components';

/**
 * Stili per un <NwUpload dragDrop> usato come dropzone che riempie il suo contenitore,
 * al posto del riquadro di upload separato (cover delle news, blocchi media di articoli
 * e model content).
 *
 * Va applicato al box che contiene l'upload, non all'upload stesso: NwUpload non espone
 * una className, quindi le misure passano dal wrapper.
 *
 * Markup atteso:
 *   <div className="nw-dropzone-wrap">
 *       <NwUpload dragDrop ...>
 *           <div className="nw-dropzone">icona, <strong>, <small></div>
 *       </NwUpload>
 *   </div>
 */
export const nwDropzoneStyles = css`
    .nw-dropzone-wrap,
    .nw-dropzone-wrap > div,
    .ant-upload,
    .ant-upload-btn,
    .ant-upload-drag-container {
        display: block;
        inline-size: 100%;
        block-size: 100%;
    }

    .ant-upload.ant-upload-drag {
        border: 0;
        border-radius: 0;
        background: transparent;
    }

    .nw-dropzone {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.3rem;
        block-size: 100%;
        padding: 0.75rem;
        text-align: center;
        color: ${(props) => props.theme.TextColorMuted};
        transition: background 0.15s ease;

        svg {
            font-size: 1.5rem;
            color: ${(props) => props.theme.PrimaryColor};
        }

        strong {
            color: ${(props) => props.theme.TextColor};
        }

        small {
            font-size: ${(props) => props.theme.FontSizeSm};
        }
    }

    .ant-upload-drag:hover .nw-dropzone,
    .ant-upload-drag-hover .nw-dropzone {
        background: ${(props) => props.theme.LightBlueBackground};
    }
`;
